import { useRequest } from 'ahooks';
import { BFFGet } from '@/infrastructure/axios';
import { API_PREFIX } from '@/infrastructure/axios/code';
import { getProductId } from '@/infrastructure/product-info';

export interface UseOperationConfigProps {
  configName: string;
}

export interface OperationConfigResponse<T = any> {
  data: T;
}

/**
 * 获取运营配置的 Hook
 * @param props - 配置参数
 * @param props.configName - 配置名称
 * @returns 配置数据
 *
 * @example
 * ```tsx
 * const { data, loading, error } = useOperationConfig({
 *   configName: 'CONFIG_MODE'
 * });
 * ```
 */
export const useOperationConfig = <T = any>(props: UseOperationConfigProps) => {
  const { configName } = props;
  const productId = getProductId();

  const fetchConfig = async () => {
    const response = await BFFGet<OperationConfigResponse<T>>(
      `/${API_PREFIX}/api/config/operation`,
      {
        params: {
          configName,
        },
      },
    );
    return response.data;
  };

  return useRequest(fetchConfig, {
    cacheKey: `operation-config-${productId}-${configName}`,
    // 永久缓存，除非手动刷新
    cacheTime: -1,
    staleTime: -1,
    // 只在 configName 有值时才请求
    ready: !!configName,
  });
};
